import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';

// Authenticated service
const service = axios.create({
	baseURL: API_BASE_URL,
	timeout: 60000
})

// Public service (no auth token)
const publicService = axios.create({
	baseURL: API_BASE_URL,
	timeout: 60000
})

// Config
const TOKEN_PAYLOAD_KEY = 'Authorization'

// API Request interceptor (authenticated)
service.interceptors.request.use(config => {
	const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;
	if (jwtToken) {
		config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`;
	}
	return config;
}, error => {
	notification.error({ message: 'Request Error', description: 'Could not send request.' });
	return Promise.reject(error);
})

let isLoggingOut = false;
// Shared response interceptor function
const handleResponseError = (error) => {
	let notificationParam = {
		message: ''
	}

	if (error.response?.status === 401) {
		if (error.response?.data?.code === 'TOKEN_INVALID') {
			if (isLoggingOut) return Promise.reject(error)  // ← already handled, bail out
			isLoggingOut = true
			notificationParam.message = 'Session Expired'
			notificationParam.description = 'Please log in again'
			localStorage.removeItem(AUTH_TOKEN)
			store.dispatch(signOutSuccess());
			setTimeout(() => { isLoggingOut = false }, 3000)
		} else {
			return Promise.reject(error);
		}
	}

	if (error.response?.status === 400) {
		notificationParam.message = 'API Request Failed: Bad Request'
	}

	if (error.response?.status === 404) {
		notificationParam.message = 'API Request Failed: Not Found'
	}

	if (error.response?.status === 500) {
		notificationParam.message = 'Internal Server Error'
	}

	if (error.response?.status === 508) {
		notificationParam.message = 'Time Out'
	}

	notification.error(notificationParam)

	error.handled = true;
	return Promise.reject(error);
}

// API response interceptor (authenticated)
service.interceptors.response.use(
	(response) => response.data,
	handleResponseError
)

// API response interceptor (public)
publicService.interceptors.response.use(
	(response) => response.data,
	handleResponseError
)

export default service
export { publicService }
